import React from 'react';
import '../styles/RecipeBooks.css';

const RecipeBooks = () => {
    return (
        <div className="recipe-books-container">
            <div className="recipe-books-header">
                <h2>Recipe Books</h2>
                <p>Coming soon...</p>
            </div>
            
            <div className="placeholder-content">
                <div className="placeholder-icon">📚</div>
                <h3>Recipe Books Feature</h3>
                <p>This feature is currently under development. Soon you'll be able to organize your recipes into beautiful collections and share them with others.</p>
            </div>
        </div>
    );
};

export default RecipeBooks; 